import angular from 'angular';
import neatSelectComponent from './neatSelectComponent';

angular
	.module('sh.neatSelect', [])
	// <sh-neat-select>
	//   possible attributes:
	//     options="{valueField, labelField} in arrayExpression"
	//     options="arrayOfStrings"
	//     unshift="''"
	//     unshift="['','a']"
	//     unshift="{id:0, name:'N/A'}"
	//     unshift="[{id:null, name:''},{id:0, name:'N/A'}]"
	//     push="'Other'"
	//     push="['Yes','Really Yes']"
	//     push="{id:0, name:'Other'}"
	//     push="[{id:-1, name:'None of the Above'},{id:-2, name:'All of the Above'}]"
	.directive('shNeatSelect', neatSelectComponent);
